import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "page-assign-room-object" }
const _hoisted_2 = { class: "assign-object-content mt-3" }
const _hoisted_3 = { class: "custom-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElStep = _resolveComponent("ElStep")
  const _component_ElSteps = _resolveComponent("ElSteps")
  const _component_Button = _resolveComponent("Button")
  const _component_WizardStepper = _resolveComponent("WizardStepper")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_WizardStepper, null, {
      default: _withCtx(() => [
        _createVNode("h1", null, _toDisplayString(_ctx.currentStepTitle), 1),
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_ElSteps, {
            active: _ctx.activeStep,
            class: "col-lg-6"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.steps, (step) => {
                return (_openBlock(), _createBlock(_component_ElStep, {
                  key: step.title
                }))
              }), 128))
            ]),
            _: 1
          }, 8, ["active"]),
          (!!_ctx.roomObject?.id)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeStepComponent), {
                key: 0,
                roomObject: _ctx.roomObject,
                plantId: _ctx.plantId,
                roomId: _ctx.roomId,
                roomName: _ctx.roomName,
                roomType: +_ctx.roomType,
                defaultSettings: _ctx.devicesSettings,
                "onUpdate:defaultSettings": _cache[1] || (_cache[1] = ($event: any) => (_ctx.devicesSettings = $event)),
                onNextEnabled: _ctx.nextEnabledEvent
              }, null, 8, ["roomObject", "plantId", "roomId", "roomName", "roomType", "defaultSettings", "onNextEnabled"]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("footer", _hoisted_3, [
          _createVNode(_component_Button, {
            class: "p-button-text",
            onClick: _ctx.handleButtonBackAction,
            label: _ctx.$t('AppResource.Back')
          }, null, 8, ["onClick", "label"]),
          _createVNode(_component_Button, {
            class: "p-button-text ml-auto",
            onClick: _ctx.handleButtonSubmitAction,
            label: _ctx.buttonSubmitLabel,
            disabled: _ctx.nextDisabled
          }, null, 8, ["onClick", "label", "disabled"])
        ])
      ]),
      _: 1
    })
  ]))
}